export const LOCALSTORAGE_EVENTS = 'events';
export const LOCALSTORAGE_CLIENT_ID = 'clientId';
export const LOCALSTORAGE_CLIENT_SECRET = 'clientSecret';
export const LOCALSTORAGE_USER_ID = 'userId';
